<template>
  <v-list-item
    :class="{'active-nav': isActive}"
    @click="changeRoute"
    :active-class="`primary ${!isDark ? 'black' : 'white'}--text`"
  >
    <v-list-item-icon
      v-if="text"
      class="v-list-item__icon--text"
      v-text="computedText"
    />

    <v-list-item-icon v-else-if="item.class">
      <v-icon v-text="item.class" />
    </v-list-item-icon>

    <v-list-item-content v-if="item.menuItem || item.subtitle">
      <v-list-item-title v-text="item.menuItem" />

      <v-list-item-subtitle v-text="item.subtitle" />
    </v-list-item-content>
  </v-list-item>
</template>

<script>
  import Themeable from 'vuetify/lib/mixins/themeable'

  export default {
    name: 'Item',

    mixins: [Themeable],

    props: {
      item: {
        type: Object,
        default: () => ({
          href: undefined,
          class: undefined,
          subtitle: undefined,
          menuItem: undefined,
          route: undefined,
        }),
      },
      text: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      computedText () {
        if (!this.item || !this.item.menuItem) return ''

        let text = ''

        this.item.menuItem.split(' ').forEach(val => {
          text += val.substring(0, 1)
        })

        return text
      },
      href () {
        return this.item.href || (!this.item.to ? '#' : undefined)
      },
      isActive () {
        return this.$route.path === this.item.route;
      },
    },

    methods: {
      changeRoute() {
        if (this.$route.path !== this.item.route) {
          this.$router.push({ path: this.item.route });
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .active-nav {
    background-color: #1E88E5 !important;
    border-color: #1E88E5 !important;
  }
</style>
